import React from 'react';
import Unity from 'react-unity-webgl';
import styles from './styles.module.scss';
import icCloseIcon from 'assets/svg/ic_close.svg';
import PageContent from '@profile/src/Components/PageContent';
import ErrorView from '@profile/src/Components/ErrorView';
import { ErrorViewType } from '@profile/src/Components/ErrorView/config';
import Skeleton from '@profile/src/Components/Skeleton';
import { clearSessionOpenBox, storeSessionOpenBox, unityContent } from './config';
import { useTypedSelector } from '@profile/src/redux/utils';
import { logOpenBoxEvent } from '@profile/src/utils/analytic';
import Modal from '@profile/src/Components/Modal';

const OpenThetanBoxModal = ({
  onClose,
  onRefresh,
  boxType,
  amount,
  boxName
}) => {
  const accessToken = useTypedSelector(state => state.userSignIn.accessToken || '');
  const thcBalance = useTypedSelector(state => state.connectWallet.thcBalance);
  const thgBalance = useTypedSelector(state => state.connectWallet.thgBalance);
  const userId = useTypedSelector(state => {
    var _state$userProfile$us;

    return (_state$userProfile$us = state.userProfile.user) === null || _state$userProfile$us === void 0 ? void 0 : _state$userProfile$us.id;
  });
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  const renderContent = () => null;

  const renderError = () => /*#__PURE__*/React.createElement(ErrorView, {
    className: styles.error,
    config: {
      type: ErrorViewType.Custom,
      title: 'OOPS!',
      content: 'Sorry, you can’t open box at that time. Please try again later'
    }
  });

  const renderLoading = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.placeholder
    }, /*#__PURE__*/React.createElement(Skeleton, {
      className: styles.label
    }), /*#__PURE__*/React.createElement(Skeleton, {
      className: styles.box
    }), /*#__PURE__*/React.createElement(Skeleton, {
      className: styles.label
    }));
  };

  React.useEffect(() => {
    unityContent.on('loaded', () => {
      setLoading(false);
    });
    unityContent.on('quitted', () => {
      onClose();
    });
    unityContent.on('OpenBoxDone', () => {
      onClose();
      onRefresh();

      if (thcBalance && thgBalance && userId) {
        logOpenBoxEvent({
          THC: thcBalance,
          THG: thgBalance,
          boxAmount: 1,
          boxName,
          boxType,
          userId
        });
      }
    });
    unityContent.on('error', () => {
      setLoading(false);
      setError(true);
    });
  }, []);
  React.useLayoutEffect(() => {
    if (!accessToken) {
      setError(true);
      return undefined;
    }

    storeSessionOpenBox(accessToken, boxType, amount);
    return () => {
      clearSessionOpenBox();
    };
  }, [accessToken, amount, boxType]);
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      onClose();
      onRefresh();
    },
    className: styles.close
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.closeIcon,
    src: icCloseIcon
  }))), /*#__PURE__*/React.createElement(PageContent, {
    invalidated: loading,
    loading: loading,
    error: error,
    renderLoading: renderLoading,
    renderError: renderError,
    renderContent: renderContent
  }), !error && /*#__PURE__*/React.createElement(Unity, {
    className: loading && styles.hide,
    unityContent: unityContent
  })));
};

export default OpenThetanBoxModal;